<template>
  <div class="btn" :class="[props.size, props.type, props.disabled ? 'disabled' : '']">
    {{ props.text }}
  </div>
</template>
<script lang="ts" setup>
  const props = defineProps({
    text: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  })
</script>
<style lang="scss" scoped>
  .btn {
    transition: 0.2s ease-in-out;
    display: flex;
    padding: 10px 0;
    width: 100px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    color: #4d5969;
    text-align: center;
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-size: 0.75rem; // 12px
    font-weight: 600;
    cursor: pointer;
    &.sm {
      width: 64px;
      font-size: 0.87rem; // 14px
      padding: 8px 12px;
      line-height: 19px; /* 135.714% */
      border-radius: 8px;
    }
    &.md {
      font-size: 1rem; // 16px
      padding: 14px 16px;
      border-radius: 10px;
    }
    &.lg {
      width: 140px;
      padding: 14px 16px;
      font-size: 1.12rem; // 18px
      border-radius: 12px;
    }
    &.auto {
      width: auto;
    }
    &.w-100 {
      width: 100%;
    }
    // primary
    &.primary {
      background: var(--Primary-500, #0064ff);
      color: var(--White, #fff);
      &:not(.disabled):hover {
        background: var(--Primary-600, #0052cc);
        color: var(--White, #fff);
      }
      &:not(.disabled):active {
        background: var(--Primary-700, #003f99);
        color: var(--White, #fff);
      }
    }
    // primary-line
    &.primary-line {
      background: var(--White, #fff);
      color: var(--Primary-500, #0064ff);
      border: 1px solid;
      border-color: var(--Primary-500, #0064ff);
      &.disabled {
        background: var(--White, #fff);
        border-color: var(--Gray-300, #e3e3e3);
      }
      &:not(.disabled):hover {
        background: var(--Primary-100, #f2f7ff);
        color: var(--Primary-600, #0052cc);
        border-color: var(--Primary-600, #0052cc);
      }
      &:not(.disabled):active {
        background: var(--Primary-200, #e0ebfd);
        color: var(--Primary-700, #003f99);
        border-color: var(--Primary-700, #003f99);
      }
    }
    // red
    &.red {
      background: var(--Red-500, #fe5051);
      color: var(--White, #fff);
      &:not(.disabled):hover {
        background: var(--Red-600, #d94344);
        color: var(--White, #fff);
      }
      &:not(.disabled):active {
        background: var(--Red-700, #b03335);
        color: var(--White, #fff);
      }
    }
    // red-line
    &.red-line {
      background: var(--White, #fff);
      color: var(--Red-500, #fe5051);
      border: 1px solid;
      border-color: var(--Red-500, #fe5051);
      &.disabled {
        background: var(--White, #fff);
        border-color: var(--Gray-300, #e3e3e3);
      }
      &:not(.disabled):hover {
        background: var(--Red-100, #ffecec);
        color: var(--Red-600, #b03335);
        border-color: var(--Red-600, #b03335);
      }
      &:not(.disabled):active {
        background: var(--Red-200, #ffcdcd);
        color: var(--Red-700, #b03335);
        border-color: var(--Red-700, #b03335);
      }
    }
    // secondary
    &.secondary {
      background: var(--White, #fff);
      color: var(--Gray-800, #4d5969);
      border: 1px solid;
      border-color: var(--Gray-300, #e3e3e3);
      &.disabled {
        background: var(--White, #fff);
      }
      &:not(.disabled):hover {
        background: var(--Gray-200, #f2f3f9);
      }
      &:not(.disabled):active {
        background: var(--Gray-400, #c4c4c4);
      }
    }
    // disabled
    &.disabled {
      cursor: not-allowed;
      background: var(--Gray-300, #e3e3e3);
      color: #4d596930;
    }
  }
</style>
